import React, { Component, createRef } from 'react'
import './Auth.css'
import { auth, database, signInWithEmailAndPassword, createUserWithEmailAndPassword, ref, update } from '../../firebase'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import Logotipo from '../commons/Logotipo.jsx'
import Loading from '../commons/Loading.jsx'
import { BtnPrimary } from '../commons/Buttons.jsx'

class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      error: null,
      saving: false
    }
    this.handleEmail = this.handleEmail.bind(this)
    this.handlePassword = this.handlePassword.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleEmail (val) {
    this.setState({
      email: val.target.value,
      error: null
    })
  }
  handlePassword (val) {
    this.setState({
      password: val.target.value,
      error: null
    })
  }
  handleSubmit (ev) {
    ev.preventDefault()
    this.setState({
      saving: true
    })
    signInWithEmailAndPassword(auth, this.state.email, this.state.password)
      .then(() => {
        this.setState({
          saving: false
        })
      })
      .catch((err) => {
        switch (err.code) {
          case 'auth/wrong-password':
            this.setState({
              error: 'Contraseña incorrecta',
              password: '',
              saving: false
            })
            break
          case 'auth/invalid-email':
            this.setState({
              error: 'Email inválido',
              email: '',
              password: '',
              saving: false
            })
            break
          case 'auth/user-not-found':
            this.setState({
              error: 'Usuario no encontrado',
              email: '',
              password: '',
              saving: false
            })
            break
          case 'auth/user-disabled':
            this.setState({
              error: 'Cuenta deshabilitada',
              saving: false
            })
            break
          default:
            this.setState({
              error: err.code,
              email: '',
              password: '',
              saving: false
            })
        }
      })
  }
  render () {
    return (
      <div ref={this.props.nodeRef} className='auth__login'>
        <div>
          <div className='logotipo'><Logotipo /></div>
          <p>Inicia sesión con tu correo electrónico</p>
          <form>
            <input type='email' name='email' placeholder='Correo electrónico' value={this.state.email} onChange={this.handleEmail} />
            <input type='password' name='password' placeholder='Contraseña' value={this.state.password} onChange={this.handlePassword} />
            <BtnPrimary type='submit' onClick={this.handleSubmit} disabled={this.state.saving}>{this.state.saving ? <Loading /> : 'Iniciar sesión'}</BtnPrimary>
            {this.state.error && <div className='error'>{this.state.error}</div>}
          </form>
          <div className='auth__small'>
            <a href='#forget'>¿Olvidaste tu contraseña?</a>
          </div>
          <p>¿No tienes una cuenta?, <a href='#register' onClick={(ev) => { ev.preventDefault(); this.props.handleRegister(true) }}>regístrate</a></p>
        </div>
      </div>
    )
  }
}

class Register extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      password: '',
      error: null,
      saving: false
    }
    this.handleName = this.handleName.bind(this)
    this.handleEmail = this.handleEmail.bind(this)
    this.handlePassword = this.handlePassword.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleName (val) {
    this.setState({
      name: val.target.value,
      error: null
    })
  }
  handleEmail (val) {
    this.setState({
      email: val.target.value,
      error: null
    })
  }
  handlePassword (val) {
    this.setState({
      password: val.target.value,
      error: null
    })
  }
  handleSubmit (ev) {
    ev.preventDefault()
    if (this.state.name !== '') {
      this.setState({
        saving: true
      })
      createUserWithEmailAndPassword(auth, this.state.email, this.state.password)
        .then((res) => {
          const usersRef = ref(database, 'usuarios/index')
          return update(usersRef, {
            [res.user.uid]: {
              name: this.state.name,
              email: res.user.email,
              photo: res.user.photoURL || 'https://firebasestorage.googleapis.com/v0/b/stadium-data.appspot.com/o/usuarios%2Favatars%2Fdefault.png?alt=media&token=9a1d1625-171e-4b97-9612-f9a5a693ba63',
              provider: 'password'
            }
          })
        })
        .then(() => {
          this.setState({
            saving: false
          })
        })
        .catch((err) => {
          switch (err.code) {
            case 'auth/email-already-in-use':
              this.setState({
                error: 'Ya existe una cuenta con ese correo',
                password: '',
                saving: false
              })
              break
            case 'auth/invalid-email':
              this.setState({
                error: 'Email inválido',
                password: '',
                saving: false
              })
              break
            case 'auth/weak-password':
              this.setState({
                error: 'Tu contraseña debe ser más complicada',
                password: '',
                saving: false
              })
              break
            case 'auth/operation-not-allowed':
              this.setState({
                error: 'En estos momentos no es posible registrarse',
                saving: false
              })
              break
            default:
              this.setState({
                error: err.code,
                email: '',
                password: '',
                saving: false
              })
          }
        })
    } else {
      this.setState({
        error: 'No olvides tu nombre'
      })
    }
  }
  render () {
    return (
      <div ref={this.props.nodeRef} className='auth__register'>
        <div>
          <div className='logotipo'><Logotipo /></div>
          <p>Regístrate con tu correo electrónico</p>
          <form>
            <input type='text' name='name' placeholder='Nombre completo' value={this.state.name} onChange={this.handleName} />
            <input type='email' name='email' placeholder='Correo electrónico' value={this.state.email} onChange={this.handleEmail} />
            <input type='password' name='password' placeholder='Contraseña' value={this.state.password} onChange={this.handlePassword} />
            <BtnPrimary type='submit' onClick={this.handleSubmit} disabled={this.state.saving}>{this.state.saving ? <Loading /> : 'Registrarte'}</BtnPrimary>
            {this.state.error && <div className='error'>{this.state.error}</div>}
          </form>
          <div className='auth__small'>Al registrarte, aceptas nuestras <a href='#condiciones'>condiciones</a> y <a href='#política'>política de privacidad</a>.</div>
          <p>¿Ya tienes una cuenta?, <a href='#login' onClick={(ev) => { ev.preventDefault(); this.props.handleRegister(false) }}>entrar</a></p>
        </div>
      </div>
    )
  }
}

export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      register: false
    }
    this.loginRef = createRef()
    this.registerRef = createRef()
    this.handleRegister = this.handleRegister.bind(this)
  }
  handleRegister (val) {
    this.setState({
      register: val
    })
  }
  render () {
    return (
      <div className='auth'>
        <div className='auth__row'>
          <div className='auth__help'>
            <div>
              <h1>Stadium ¡todos juegan!</h1>
              <p>¿Quién de tus amigos es el mejor en sus quinielas?, ¿el verdadero gurú?, ¿the one and only? La idea de es jugar, para saber quien es el mejor para predecir partido a partido.</p>
              <p>Stadium es una plataforma para competir con tus amigos, familia o colegas y saber de una vez por todas quien es el mejor y más conocedor del fútbol.</p>
              <h2>¿Qué hay en Stadium?</h2>
              <p>Olvídate del martirio de armar la quiniela. Stadium pone al alcance de todos los aficionados y administradores la herramienta definitiva que ayudará a crear y administrar quinielas de una manera muy sencilla, donde cada quien podrá dar seguimiento de sus propios resultados y los de sus competidores.</p>
              <p>Para esta temporada tenemos dos opciones:</p>
              <p><b>Liga MX</b> (9 partidos por jornada) y <b>Liga MX con partidos internacionales</b> (18 partidos por jornada), por 17 jornadas tú elige cual quieres jugar.</p>
              <p>Con Stadium creas grupos entre colegas, familia y amigos.</p>
            </div>
          </div>
          <div className='auth__container'>
            <div className='logotipo'><Logotipo dark /></div>
            <SwitchTransition mode='out-in'>
              <CSSTransition
                key={this.state.register ? 'register' : 'login'}
                nodeRef={this.state.register ? this.registerRef : this.loginRef}
                timeout={400}
                classNames={'anim'}>
                {this.state.register ? (
                  <Register nodeRef={this.registerRef} handleRegister={this.handleRegister} />
                ) : (
                  <Login nodeRef={this.loginRef} handleRegister={this.handleRegister} />
                )}
              </CSSTransition>
            </SwitchTransition>
          </div>
        </div>
        <div className='auth__footer'><a href='#acerca'>Acerca de</a> <a href='#contacto'>Contáctanos</a> <a href='#aviso'>Aviso de privacidad</a> © {new Date().getFullYear()} Stadium</div>
      </div>
    )
  }
}
